const FIREBASE_CONFIG = {
  apiKey: 'AIzaSyCZgx7Wa_S-MB7i0ZU0upkLNRVRsuNgpu0',
  appId: '1:65229005291:web:250f0adf97a382d6e9b9ae',
  authDomain: 'promobit-login.firebaseapp.com',
  databaseURL: 'https://promobit-login.firebaseio.com',
  messagingSenderId: '65229005291',
  projectId: 'promobit-login',
  storageBucket: 'promobit-login.appspot.com',
};

export default FIREBASE_CONFIG;
